// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manageUsersCheckbox .MuiSvgIcon-root {
  height: 16px !important;
  width: 16px !important;
}
.MuiButtonBase-root.MuiCheckbox-root {
  padding: 0px !important;
}

.permissionDiv {
  margin-top: 48px;
  width: 100%;
  border-radius: 12px;
  background: var(--Neutral-2, #fafafa);
  padding: 20px;
}

.inviteModal .MuiPaper-root.MuiDialog-paper {
  width: 800px;
  max-width: 800px;
  border-radius: 16px;
}

.productDescription .MuiInputBase-root.MuiOutlinedInput-root {
  padding: 8.5px 0px 8.5px 14px;
}

.multiselect.MuiAutocomplete-root .MuiOutlinedInput-root {
  padding: 0px 0px 0px 12px !important;
  margin-top: 8px;
}
.multiselect.MuiAutocomplete-root .MuiAutocomplete-endAdornment {
  top: 20px;
}
.multiselectInput .MuiInputBase-root {
  min-height: 40px;
  height: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/managerUsers/manageUsers.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,eAAe;AACjB;AACA;EACE,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,YAAY;AACd","sourcesContent":[".manageUsersCheckbox .MuiSvgIcon-root {\n  height: 16px !important;\n  width: 16px !important;\n}\n.MuiButtonBase-root.MuiCheckbox-root {\n  padding: 0px !important;\n}\n\n.permissionDiv {\n  margin-top: 48px;\n  width: 100%;\n  border-radius: 12px;\n  background: var(--Neutral-2, #fafafa);\n  padding: 20px;\n}\n\n.inviteModal .MuiPaper-root.MuiDialog-paper {\n  width: 800px;\n  max-width: 800px;\n  border-radius: 16px;\n}\n\n.productDescription .MuiInputBase-root.MuiOutlinedInput-root {\n  padding: 8.5px 0px 8.5px 14px;\n}\n\n.multiselect.MuiAutocomplete-root .MuiOutlinedInput-root {\n  padding: 0px 0px 0px 12px !important;\n  margin-top: 8px;\n}\n.multiselect.MuiAutocomplete-root .MuiAutocomplete-endAdornment {\n  top: 20px;\n}\n.multiselectInput .MuiInputBase-root {\n  min-height: 40px;\n  height: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
